(() => {
  const SLIDER_SELECTOR = '.flickity-slider';

  function stripAriaHiddenWithin(root) {
    // root can be document or a specific flickity-slider element
    const sliders = root.matches?.(SLIDER_SELECTOR)
      ? [root]
      : Array.from(root.querySelectorAll?.(SLIDER_SELECTOR) || []);

    for (const slider of sliders) {
      // Remove aria-hidden from ANY element inside the slider (including slide wrappers)
      const hiddenNodes = slider.querySelectorAll('[aria-hidden]');
      for (const el of hiddenNodes) {
        el.removeAttribute('aria-hidden');
      }

      // If the slider element itself ever gets aria-hidden (rare but possible)
      if (slider.hasAttribute('aria-hidden')) {
        slider.removeAttribute('aria-hidden');
      }
    }
  }

  // 1) Run ASAP (in case tool runs early)
  try { stripAriaHiddenWithin(document); } catch (e) {}

  // 2) Run again on DOMContentLoaded (covers most page-load audits)
  document.addEventListener('DOMContentLoaded', () => stripAriaHiddenWithin(document), { once: true });

  // 3) Keep enforcing: if Flickity re-adds aria-hidden, remove it immediately
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // Attribute changes: aria-hidden added/changed
      if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
        const el = m.target;
        // Only touch elements inside a flickity-slider
        if (el.closest && el.closest(SLIDER_SELECTOR)) {
          el.removeAttribute('aria-hidden');
        }
      }

      // New nodes inserted: strip within them too
      if (m.type === 'childList') {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue; // element nodes only
          stripAriaHiddenWithin(node);
        }
      }
    }
  });

  // Observe the whole doc: flickity can mutate anywhere
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  // 4) Fallback triggers for late flickity init / layout shifts
  window.addEventListener('load', () => stripAriaHiddenWithin(document));
  window.addEventListener('pageshow', () => stripAriaHiddenWithin(document)); // bfcache restores
})();

document.addEventListener('ajaxProduct:added', (event) => {
  const el = document.getElementById('CartDrawerConfirm');
  if (!el) return;

  const title = event.detail?.product?.product_title || 'Item';
  el.textContent = `${title} added to cart.`;
  // Focus it so it's announced immediately
  el.focus();

  // Optional: clear after a moment so it won't be read later
  setTimeout(() => { el.textContent = ''; }, 1500);
});